module.exports = __webpack_public_path__ + "img/IMG_8155_L_BlackMatted_MockedUp.6efb36e5.jpg";